import { render, staticRenderFns } from "./userinfolist.vue?vue&type=template&id=3999fa7b&scoped=true"
import script from "./userinfolist.vue?vue&type=script&lang=js"
export * from "./userinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999fa7b",
  null
  
)

export default component.exports